import SceButton from '../../../../../Common/CommonComponents/sceButton';
import { getLocalizedStrings } from '../../twoFactorAuthenticationStrings';
import classes from '../../twoFactorAuthContainer.scss';

function EmailStepOne(props) {
    let strings = getLocalizedStrings('twoFactorAuthenticationStrings');
    return (
        <div className={classes.card}>      
            <div className={classes.btnsPadding}>
            <div className={[classes.verifyLogIn, 'sce-center-alg'].join(" ")}> {strings.VerifyYourEmailAddress}
                <div className={["sce-content-row", classes.verifyAddress].join(" ")}> {props.formatEmailIdWithStar(props.userEnteredValue)} </div>
            </div>
            <div className={["sce-content-row", classes.subText].join(" ")}>  {strings.VerifyYourEmailAddressSubText} </div>
            <div className={['sce-center-alg', "sce-content-row"].join(" ")}>
                <SceButton
                    id="email"
                    value={strings.continue}
                    onClick={() => props.sendCodeHandler("email")}
                    isDisabled={(props.disableSendCodeBtn) ? true : false}
                    buttonType={(props.disableSendCodeBtn) ? 'sceBtnDisabledPrimary' : 'primary'}
                />
            </div>
        </div>
        </div>
    );
}

export default EmailStepOne;